module.exports = __webpack_public_path__ + "static/media/renly.6411e084.jpg";